import { FiltersChip } from "app/pages/sales-intelligence/common-components/filters-panel";

import type { IFilterViewBaseModelProps } from "../../../types/filterInstance";
import type { DynamicComboboxFilterOptions } from "../../../types/filterOptions";
import { composeFieldChipLabel, resolveOptionLabel } from "../../../utils/filterOptions";

const EnumComboboxFilterResult = ({
    filter,
    value,
    isActionEnabled = true,
    onFilterUpdate,
}: IFilterViewBaseModelProps<string, DynamicComboboxFilterOptions>) => {
    if (!value) {
        return null;
    }

    const optionLabel = resolveOptionLabel(filter.options.options, value);

    return (
        <FiltersChip
            text={composeFieldChipLabel(filter.options.label, optionLabel)}
            hideActionButton={!isActionEnabled}
            onClose={() => onFilterUpdate()}
        />
    );
};

export default EnumComboboxFilterResult;
